import { useEffect, useCallback } from "react";
import Cookies from "js-cookie";
import { useStoreState } from "../store/useStore";

const DEMO_TRADING_CHANGE_KEY = "demo-trading-change";

interface DemoTradingChangeData {
  timestamp: number;
  isDemoTrading: boolean;
}

const useDemoTradingListen = () => {
  const { localeLink } = useStoreState();

  const handleMessage = useCallback((event: StorageEvent) => {
    if (event.key !== DEMO_TRADING_CHANGE_KEY || !event.newValue) {
      return;
    }

    // 检查是否是当前视窗
    if (document.hasFocus()) {
      return;
    }

    if (sessionStorage) {
      sessionStorage.removeItem("global-role");
    }
    window.location.reload();
  }, []);

  const triggerDemoTradingChange = useCallback((isDemoTrading: boolean) => {
    const changeData: DemoTradingChangeData = {
      //localstorage当数据未发生改变时不触发
      timestamp: Date.now(),
      isDemoTrading
    };
    localStorage.setItem(DEMO_TRADING_CHANGE_KEY, JSON.stringify(changeData));
  }, []);

  const toLiveTrading = useCallback(() => {
    Cookies.remove("Global-UserViewType");
    if (sessionStorage) {
      sessionStorage.removeItem("global-role");
    }

    triggerDemoTradingChange(false);

    setTimeout(() => {
      if (
        window.location.pathname.includes("futures") ||
        window.location.pathname.includes("spot") ||
        window.location.pathname.includes("/activity")
      ) {
        window.location.reload();
      } else {
        window.location.href = `/futures${localeLink}/BTC-USDT`;
      }
    }, 100);
  }, [localeLink, triggerDemoTradingChange]);

  useEffect(() => {
    window.addEventListener("storage", handleMessage);

    return () => {
      window.removeEventListener("storage", handleMessage);
    };
  }, [handleMessage]);

  return { triggerDemoTradingChange, toLiveTrading };
};

export default useDemoTradingListen;
